import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "form" }
const _hoisted_3 = {
  key: 0,
  class: "stepOne"
}
const _hoisted_4 = { class: "radio-label-title" }
const _hoisted_5 = { class: "options-wrapper" }
const _hoisted_6 = ["id", "name", "value", "onUpdate:modelValue", "tabindex"]
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "stepTwo"
}
const _hoisted_10 = { class: "form__row" }
const _hoisted_11 = { class: "form__column half-width" }
const _hoisted_12 = {
  class: "text-label",
  for: "firstName"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form__column half-width" }
const _hoisted_15 = {
  class: "text-label",
  for: "lastName"
}
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "form__column" }
const _hoisted_18 = {
  class: "text-label",
  for: "phoneNumber"
}
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "form__column" }
const _hoisted_21 = {
  class: "text-label",
  for: "email"
}
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "form__column" }
const _hoisted_24 = {
  class: "text-label",
  for: "address"
}
const _hoisted_25 = ["placeholder", "aria-label"]
const _hoisted_26 = ["placeholder", "aria-label"]
const _hoisted_27 = ["placeholder", "aria-label"]
const _hoisted_28 = {
  key: 0,
  class: "form-block__response-text"
}
const _hoisted_29 = {
  key: 2,
  class: "stepThree"
}
const _hoisted_30 = { class: "font-light" }
const _hoisted_31 = { class: "radio-label-title" }
const _hoisted_32 = { class: "options-wrapper" }
const _hoisted_33 = ["id", "name", "value", "onUpdate:modelValue", "tabindex"]
const _hoisted_34 = ["for"]
const _hoisted_35 = {
  class: "form__row",
  style: {"margin-top":"1.5rem"}
}
const _hoisted_36 = { class: "form__column" }
const _hoisted_37 = {
  class: "text-label",
  for: "message"
}
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = ["id", "onUpdate:modelValue", "onKeypress"]
const _hoisted_40 = ["for"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "font-light bottom-text" }
const _hoisted_43 = {
  key: 3,
  class: "form-submitted"
}
const _hoisted_44 = {
  key: 4,
  class: "required-text"
}
const _hoisted_45 = {
  key: 0,
  class: "required-text__item"
}
const _hoisted_46 = {
  key: 1,
  class: "required-text__item"
}
const _hoisted_47 = {
  key: 2,
  class: "required-text__item"
}
const _hoisted_48 = {
  key: 5,
  class: "button-container"
}
const _hoisted_49 = { class: "step-text" }
const _hoisted_50 = {
  key: 0,
  class: "form-block__response-text"
}
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentStep > 1 && !_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "form__button-return",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args))),
          disabled: _ctx.currentStep === 1,
          "aria-label": "Back",
          id: "returnButton"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentStep === 1 && !_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.questionListStepOne, (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "question-item"
              }, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", _hoisted_4, _toDisplayString(question.questionText), 1),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: answerIndex,
                        class: "question-item-options"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: 'item' + index + '-answer' + answerIndex,
                          name: 'item' + index,
                          value: answer,
                          class: "radio-input",
                          "onUpdate:modelValue": ($event: any) => ((question.selectedAnswer) = $event),
                          tabindex: question.selectedAnswer === answer || !question.selectedAnswer ? 0 : -1,
                          required: ""
                        }, null, 8, _hoisted_6), [
                          [_vModelRadio, question.selectedAnswer]
                        ]),
                        _createElementVNode("label", {
                          class: "radio-label",
                          for: 'item' + index + '-answer' + answerIndex
                        }, _toDisplayString(answer), 9, _hoisted_7)
                      ]))
                    }), 128))
                  ]),
                  _hoisted_8
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep === 2 && !_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("MultiFormBlock.FirstName")), 1),
                _withDirectives(_createElementVNode("input", {
                  tabindex: "0",
                  type: "text",
                  id: "firstName",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.multiFormModel.firstName) = $event)),
                  placeholder: _ctx.$t("MultiFormBlock.FirstNamePlaceholder"),
                  required: ""
                }, null, 8, _hoisted_13), [
                  [_vModelText, _ctx.multiFormModel.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("MultiFormBlock.LastName")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "lastName",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.multiFormModel.lastName) = $event)),
                  placeholder: _ctx.$t("MultiFormBlock.LastNamePlaceholder"),
                  required: ""
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.multiFormModel.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("MultiFormBlock.PhoneNumber")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                id: "phoneNumber",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.multiFormModel.phoneNumber) = $event)),
                placeholder: _ctx.$t("MultiFormBlock.PhoneNumberPlaceholder"),
                required: ""
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.multiFormModel.phoneNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("MultiFormBlock.Email")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.multiFormModel.email) = $event)),
                placeholder: _ctx.$t("MultiFormBlock.EmailPlaceholder"),
                required: ""
              }, null, 8, _hoisted_22), [
                [_vModelText, _ctx.multiFormModel.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("MultiFormBlock.Address")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "address",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.multiFormModel.address) = $event)),
                placeholder: _ctx.$t("MultiFormBlock.AddressPlaceholder"),
                "aria-label": _ctx.$t("MultiFormBlock.AddressPlaceholder"),
                required: ""
              }, null, 8, _hoisted_25), [
                [_vModelText, _ctx.multiFormModel.address]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "postCode",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.multiFormModel.postCode) = $event)),
                class: "margin-top",
                placeholder: _ctx.$t("MultiFormBlock.ZipCodePlaceholder"),
                "aria-label": _ctx.$t("MultiFormBlock.ZipCodePlaceholder"),
                required: ""
              }, null, 8, _hoisted_26), [
                [_vModelText, _ctx.multiFormModel.postCode]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "city",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.multiFormModel.city) = $event)),
                class: "margin-top",
                placeholder: _ctx.$t("MultiFormBlock.CityPlaceholder"),
                "aria-label": _ctx.$t("MultiFormBlock.CityPlaceholder"),
                required: ""
              }, null, 8, _hoisted_27), [
                [_vModelText, _ctx.multiFormModel.city]
              ])
            ]),
            (_ctx.displayResponseMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.responseMsg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep === 3 && !_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("p", null, _toDisplayString(_ctx.formData.topText), 1),
            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.formdata.middleText), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.questionListStepThree, (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "question-item",
                id: "question-item"
              }, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", _hoisted_31, _toDisplayString(question.questionText), 1),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: answerIndex,
                        class: "question-item-options"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: 'item' + index + '-answer' + answerIndex,
                          name: 'item' + index,
                          value: answer,
                          "onUpdate:modelValue": ($event: any) => ((question.selectedAnswer) = $event),
                          tabindex: question.selectedAnswer === answer || !question.selectedAnswer ? 0 : -1
                        }, null, 8, _hoisted_33), [
                          [_vModelRadio, question.selectedAnswer]
                        ]),
                        _createElementVNode("label", {
                          class: "radio-label",
                          for: 'item' + index + '-answer' + answerIndex
                        }, _toDisplayString(answer), 9, _hoisted_34)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("MultiFormBlock.Message")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "message",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.multiFormModel.message) = $event)),
                  placeholder: _ctx.$t("MultiFormBlock.MessagePlaceholder")
                }, "\r\n          ", 8, _hoisted_38), [
                  [_vModelText, _ctx.multiFormModel.message]
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.checkboxList, (checkbox, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "checkbox-item"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: 'checkbox' + index,
                  "onUpdate:modelValue": ($event: any) => ((checkbox.selected) = $event),
                  onKeypress: _withKeys(($event: any) => (_ctx.toggleCheckbox(index)), ["enter"]),
                  required: ""
                }, null, 40, _hoisted_39), [
                  [_vModelCheckbox, checkbox.selected]
                ]),
                _createElementVNode("label", {
                  for: 'checkbox' + index
                }, [
                  _createElementVNode("span", {
                    class: "checkbox-text font-light",
                    innerHTML: _ctx.getCheckboxText(checkbox)
                  }, null, 8, _hoisted_41)
                ], 8, _hoisted_40)
              ]))
            }), 128)),
            _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.formdata.bottomText), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("MultiFormBlock.FormSubmitted")), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            (_ctx.currentStep === 1 && !_ctx.isStepOneValid && _ctx.stepOneValidationInfoText != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.stepOneValidationInfoText), 1))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 2 && !_ctx.isStepTwoValid && _ctx.stepTwoValidationInfoText != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.stepTwoValidationInfoText), 1))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 3 && !_ctx.isStepThreeValid && _ctx.stepThreeValidationInfoText !== '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.stepThreeValidationInfoText), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("p", _hoisted_49, "Steg " + _toDisplayString(_ctx.currentStep) + " (" + _toDisplayString(_ctx.totalSteps) + ")", 1),
            (_ctx.displayResponseMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.responseMsg), 1))
              : _createCommentVNode("", true),
            (_ctx.currentStep < _ctx.totalSteps)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button form__button button--base button--primary",
                  id: "nextStepButton",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                  disabled: (_ctx.currentStep === 1 && !_ctx.isStepOneValid) || (_ctx.currentStep === 2 && !_ctx.isStepTwoValid)
                }, _toDisplayString(_ctx.$t("MultiFormBlock.ButtonNext")), 9, _hoisted_51))
              : _createCommentVNode("", true),
            (_ctx.currentStep === _ctx.totalSteps)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "button form__button button--base button--primary",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitFormData && _ctx.submitFormData(...args))),
                  disabled: _ctx.currentStep === 3 && !_ctx.isStepThreeValid
                }, _toDisplayString(_ctx.$t("MultiFormBlock.ButtonSend")), 9, _hoisted_52))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}